import { useSelector } from 'react-redux';

import { selectCheckoutDetails } from '../../../selectors/publishTerms';
import { selectMasterHasNotEnoughMoney } from '../../../selectors/balance';
import { selectTotalAmount } from '../../../selectors/checkoutInfo';

import { getDetails, getTotalValue } from './utils';

export const useMultilineTotalContainer = () => {
  const checkoutDetails = useSelector(selectCheckoutDetails);
  const totalAmount = useSelector(selectTotalAmount);
  const notEnoughMasterMoney = useSelector(selectMasterHasNotEnoughMoney);

  const total = getTotalValue(totalAmount);
  const details = getDetails(checkoutDetails);
  const isVisible = Boolean(totalAmount.price || details.length);

  return { details, total, notEnoughMasterMoney, isVisible };
};
